import React from 'react';
import { Box } from '@mui/material';

import * as _ from 'lodash';
import { MarginHighlight } from '../../../../types';
import { Info } from '../Info/Info';
import { Margin } from '../Margin/Margin';
import { CustomNumber } from '../Number/Number';
import { priceFormat } from '../../../../components/tableCellRenders';

export const MarginSummary = ({
  marginHighlights,
  grossMargin,
  netMarginHighlights,
  netMargin,
  newGrossMargin,
  newNetMargin,
  valueLineHeight,
  calculateMargins,
}: {
  marginHighlights?: MarginHighlight[];
  grossMargin?: number;
  netMarginHighlights?: MarginHighlight[];
  netMargin?: number;
  newGrossMargin?: number;
  newNetMargin?: number;
  // Shared value line height when the cards sit in a row with other stats
  valueLineHeight?: string;
  grossMarginheader?: string;
  netMarginheader?: string;
  calculateMargins?: () => void;
}) => {
  if (
    _.isNil(grossMargin) ||
    _.isNil(marginHighlights) ||
    _.isNil(netMargin) ||
    _.isNil(netMarginHighlights)
  )
    return (
      <>
        <Info
          title={
            _.isNil(newGrossMargin) ? 'Gross margin' : 'Gross margin old / new'
          }
        >
          <Box
            display="flex"
            alignItems="baseline"
            pt={valueLineHeight ? '0.6rem' : undefined}
          >
            <CustomNumber
              value={grossMargin}
              typographyStyle={{ lineHeight: valueLineHeight }}
            >
              {priceFormat({ value: grossMargin })}
            </CustomNumber>
            {!_.isNil(newGrossMargin) && (
              <CustomNumber
                value={newGrossMargin}
                typographyStyle={{
                  color: 'text.secondary',
                  lineHeight: valueLineHeight,
                }}
              >
                {priceFormat({ value: newGrossMargin })}
              </CustomNumber>
            )}
          </Box>
        </Info>
        <Info
          title={_.isNil(newNetMargin) ? 'Net margin' : 'Net margin old / new'}
        >
          <Box
            display="flex"
            alignItems="baseline"
            pt={valueLineHeight ? '0.6rem' : undefined}
          >
            <CustomNumber
              value={netMargin}
              typographyStyle={{ lineHeight: valueLineHeight }}
            >
              {priceFormat({ value: netMargin })}
            </CustomNumber>
            {!_.isNil(newNetMargin) && (
              <CustomNumber
                value={newNetMargin}
                typographyStyle={{
                  color: 'text.secondary',
                  lineHeight: valueLineHeight,
                }}
              >
                {priceFormat({ value: newNetMargin })}
              </CustomNumber>
            )}
          </Box>
        </Info>
      </>
    );

  return (
    <Margin
      grossMarginHighlights={marginHighlights}
      grossMargin={grossMargin}
      netMargin={netMargin}
      netMarginHighlights={netMarginHighlights}
      newGrossMargin={newGrossMargin}
      newNetMargin={newNetMargin}
      valueLineHeight={valueLineHeight}
      calculateMargins={calculateMargins}
    />
  );
};
